module.exports = __webpack_public_path__ + "static/media/PDF_38.1a2371e5.pdf";